document.addEventListener('DOMContentLoaded', () => {
  const LOCAL_STORAGE_KEY = 'geotvch_wishlist_v6'; 
  let wishlist = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || [];
  const wishlistCount = document.querySelector('.wishlist-count-bubble');

  updateWishlistUI();

  document.addEventListener('click', (e) => {
    // Targets BOTH the new floating heart and any old buttons on collection pages
    const button = e.target.closest('.geotvch-wishlist-btn, .geotvch-floating-heart');
    if (!button) return; 

    e.preventDefault();
    e.stopPropagation();

    const handle = button.getAttribute('data-product-handle');
    if (!handle || handle.trim() === '') return;
    
    // Save or unsave instantly
    if (wishlist.includes(handle)) {
      wishlist = wishlist.filter(item => item !== handle);
      button.classList.remove('active');
    } else {
      wishlist.push(handle);
      button.classList.add('active');
    }
    
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(wishlist));
    
    if (wishlistCount) {
      wishlistCount.textContent = wishlist.length;
      // Hiding logic removed so your "0" badge stays visible!
    }
  });

  function updateWishlistUI() {
    if (wishlistCount) {
      wishlistCount.textContent = wishlist.length;
    }

    // Updates the active state for both button types across the whole site
    document.querySelectorAll('.geotvch-wishlist-btn, .geotvch-floating-heart').forEach(button => {
      const handle = button.getAttribute('data-product-handle');
      if (handle && wishlist.includes(handle)) {
        button.classList.add('active');
      }
    });
  }
});